(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/playmaker-widget-definition.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/playmaker-widget-definition.js');
"use strict";


const KambiWidgetDefinition = svs.oddset_kambi.components.kambiWidgetUtils.definitions.KambiWidgetDefinition;
const buildFilter = svs.oddset_kambi.components.kambiWidgetUtils.buildFilter;
const {
  WIDGET_ID,
  WIDGET_TAG
} = svs.oddset_kambi.components.kambiWidgetUtils.constants;
const PLAYMAKER_FILTER = {
  fotboll: {
    sverige: ['allsvenskan'],
    england: ['premier-league'],
    italien: ['serie-a']
  }
};
class PlaymakerWidgetDefinition extends KambiWidgetDefinition {
  constructor() {
    super(WIDGET_ID.playmakerWidget, WIDGET_TAG.playmakerWidget, {
      eventColumn2Placeholder2: [{
        widgetId: WIDGET_ID.playmakerWidget,
        order: 1,
        filter: buildFilter(PLAYMAKER_FILTER)
      }]
    });
  }
}
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.definitions.PlaymakerWidgetDefinition', PlaymakerWidgetDefinition);

 })(window);